import React from 'react';
import { DocumentIcon } from '../../Icons';
import { Nullable, SearchItemViewModel, SearchMeta } from '../types';
import { convertToBillingUrl } from '../../../nav/utils/getBillingBaseUrl';

function renderProduct(item, t): Nullable<SearchItemViewModel> {
  return {
    title: item['Name'],
    descriptionFields: [
      { type: 'Text', value: item['SKU'], title: item['SKU'] },
    ],
    chipField: {
      label: t('ProductCatalog.Product'),
      state: 'default',
      title: t('Product'),
    },
    href: convertToBillingUrl(`/apps/Product.do?method=view&id=${item['Id']}`),
  };
}

function renderProductRatePlan(item, t): Nullable<SearchItemViewModel> {
  return {
    title: item['Name'],
    descriptionFields: [
      {
        type: 'Text',
        value: item['Product.Name'],
        title: item['Product.Name'],
      },
    ],
    chipField: {
      label: t('ProductCatalog.RatePlan'),
      state: 'default',
      title: t('ProductRatePlan'),
    },
    href: convertToBillingUrl(
      `/apps/Product.do?method=view&id=${item['Product.Id']}`,
    ),
  };
}

function renderProductRatePlanCharge(item, t): Nullable<SearchItemViewModel> {
  return {
    title: item['Name'],
    descriptionFields: [
      {
        type: 'Text',
        value: item['ProductRatePlan.Name'],
        title: item['ProductRatePlan.Name'],
      },
      {
        type: 'Text',
        value: t(`ProductCatalog.ChargeType.${item['ChargeType']}`),
        title: t(`ProductCatalog.ChargeType.${item['ChargeType']}`),
      },
      {
        type: 'Text',
        value: t(`ProductCatalog.ChargeModel.${item['ChargeModel']}`),
        title: t(`ProductCatalog.ChargeModel.${item['ChargeModel']}`),
      },
    ],
    chipField: {
      label: t('ProductCatalog.Charge'),
      state: 'default',
      title: t('ProductRatePlanCharge'),
    },
    href: convertToBillingUrl(
      `/apps/Product.do?method=view&id=${item['Product.Id']}`,
    ),
  };
}

function renderItem(item, t): Nullable<SearchItemViewModel> {
  switch (item['CatalogType']) {
    case 'Product':
      return renderProduct(item, t);
    case 'ProductRatePlan':
      return renderProductRatePlan(item, t);
    case 'ProductRatePlanCharge':
      return renderProductRatePlanCharge(item, t);
    default:
      return null;
  }
}

export const ProductCatalog: SearchMeta = {
  objectType: 'ProductCatalog',
  objectLabelI18n: 'ProductCatalog.TabLabel',
  tabIcon: <DocumentIcon />,
  needsPermission: false,
  listPageUrl: convertToBillingUrl('/apps/Product.do'),
  hasAdvancedSearch: true,
  renderItem,
};
